export interface ProductPageV2EntryData {
  globalTabs: Array<TabData | FinishingOptionsTabData | SizeDimensionsTabData>;
  resolvedTabs?: Array<ResolvedTabData | DesignSpecsResolvedTabData>;
  heroGallery: CloudinaryImage[];
}

export interface TabData {
  __typename: string;
  [key: string]: unknown;
}

export interface ResolvedTabData extends TabData {
  type: string;
}

export interface DesignSpecsResolvedTabDataSelection {
  option: string;
}

export interface DesignSpecsResolvedTabData extends ResolvedTabData {
  type: typeof designSpecsTabTypename;
  value?: {
    productOptions?: {
      selections?: Array<DesignSpecsResolvedTabDataSelection>;
    };
  };
}

export interface SizeDimensionsTabData extends TabData {
  __typename: typeof sizeDimensionsTabTypename;
  tabType: string;
  tabDetails: string;
}

export interface Faq {
  question: string;
  answer: string;
}

export interface FinishingOptionsTabData extends TabData {
  __typename: typeof finishingOptionsTabTypename;
  finishingOptions: FinishingOption[];
}
export interface FinishingOption {
  headlineText: string;
  productOption: {
    selections: Array<{ option: string }>;
  };
  optionDescription?: string;
}

export interface ProductPageV2EntryDataWithContext extends ProductPageV2EntryData {
  pageContext: PageContext;
}

export interface PageContext {
  experiment?:
    | {
        name: string;
        variation: string;
      }
    | undefined;
  campaign?: string | undefined;
  treatment?: string | undefined;
}

export interface CloudinaryImage {
  cloudinaryImage: Record<string, string>;
  contentful_id: string;
}

export const designSpecsTabTypename = 'Design Specifications';
export const faqsTabTypename = 'tabFaqs';
export const finishingOptionsTabTypename = 'tabFinishingOptions';
export const sizeDimensionsTabTypename = 'tabMarkdown';
export const mailingServicesTemplateFlyoutTypename = 'Mailing List Template';
